<template>
  <button
    class="btn--close"
    @click="handleClick"
  >
    <img src="../assets/close.svg" alt="關閉" loading="lazy">
  </button>
</template>
<script>
export default {
  name: 'ButtonClose',
  methods: {
    handleClick () {
      this.$emit('click')
    }
  }
}
</script>
<style lang="scss" scoped>
.btn--close {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 44px;
  height: 44px;
  background-color: #191919;
  border-radius: 50%;
}
</style>
